<template>
  <div id="loading">
    <div id="entity">
      <h1>160WorldMeet</h1>
      <v-img id="logo" src="../assets/logo.png"> </v-img>
      <br />
    </div>
    <div id="loadinginfo">
      <b>{{ $t('message.loading.info') }}</b>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userId: String,
    roomId: String,
    token: String
  }
};
</script>

<style>
#loading {
  padding: 3vh;
  transition: all 1s;
  height: 100vh;
  display: flex;
  display: webkit-flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

#entity {
  text-align: center;
}

#logo {
  max-width: 180px;
  width: 50vw;
  display: block;
  margin: 0 auto;
}

#loadinginfo {
  text-align: center;
  margin-top: 5vw;
}
</style>
